<template>
  <div class="page-parent products-page v1 streaming">

    <section class="products-hero">
      <div class="title">

        <h1> <s-icon class="hero-icon play-icon" circle icon-font="s-icon-play"/><span class="s-text-red"> Stream </span>on any device,<br class="s-hide-xs"> anytime, anywhere!</h1>

        <SButton class="button-secondary" btn-link="/signup">Try Now</SButton>
        <SButton class="button-fill button-primary" btn-link="https://www.seedr.cc/premium" icon-font="s-icon-premium">Join Premium</SButton>

      </div>
      <div class="image">
        <img src="/assets/images/products_video_hero_asset.svg" alt="product page image" class="s-hide-pc-m">
        <img src="/assets/images/home_feature_streaming_mobile_asset.svg" alt="product page image" class="s-show-pc-m">
      </div>
    </section>

    <section class="products-details-parent" id="product-details">
      <div class="products-details-child title">
<!--        <img src="..//assets/images/icon_products_search_contextual.svg" alt="" class="">-->
        <h1>Stream Seamlessly with Our All-in-One Media Player</h1>
        <h3>Your Go-To for Video, Audio, Ebooks and More!</h3>
      </div>

      <div class="products-details-child paragraph grey">
        <p>Tired of juggling multiple apps and services just to watch a video or listen to music? An all-in-one media player eliminates the hassle by combining video and audio capabilities into one sleek, unified platform. With our powerful cloud-based media player, you can stream all your videos and songs from a single place - no more app-switching required!</p>

        <p>Juggling multiple services to access your media creates unnecessary complications. With video streaming on one platform and music on another, enjoying your digital content requires constant app switching. This fragments the user experience. Our universal media player solves this by converging video and audio functionalities into one seamless destination.</p>

        <p>Now all your cloud-based media can be streamed from a single login. No more hopping between apps and services. Just open our media player and your complete digital video and audio library is there! Experience unified access for true convenience.</p>
      </div>

      <div class="products-details-child paragraph grey">
        <h2>Why Our Media Player?</h2>

        <p>The need for media convergence is clear. In today's digital world, users want instant access to all their videos and music in one spot. Our universal media player grants that wish, enabling seamless streaming across videos and audio. One login allows endless options.</p>

        <p>The digital media landscape continues expanding exponentially. From YouTube to Spotify, users have more content than ever before. But these services exist in silos, requiring separate apps and sites. This fragmented ecosystem is inconvenient for users who want a unified destination.</p>

        <p>Our cloud-based media player solves this by delivering seamless convergence. Now videos and music can be accessed and streamed from one platform. No more juggling multiple services. Just log in to our player and your complete digital video and audio library is there.</p>

        <p>The convenience of convergence is undeniable. Users want a simplified, unified media experience. Our player offers precisely that, providing the antidote to a fragmented media world. All your videos and music, one destination.</p>

        <h3>Video Streaming</h3>

        <p>Our video player supports all major formats like MP4, AVI, MKV, FLV, MOV and more. Just upload your videos to your Seedr cloud storage and stream them directly in browser. Our player offers smooth playback and continuous streaming without interruptions. You can enjoy your video collection anywhere, anytime.</p>

        <p>Once videos are uploaded to your personal Seedr cloud storage, our integrated video player allows you to stream them seamlessly. Playback is optimized for smooth performance without buffering or stalls. Video starts instantly and runs continuously for uninterrupted viewing.</p>

        <p>Formats are never a concern. All popular video types are supported, including MP4, AVI, MKV, FLV, MOV, and many more. The player automatically detects the file format and plays it without hassle. Just sit back and enjoy the show.</p>

        <p>Accessibility is also enhanced. Since videos are stored and streamed from the cloud, you can watch them on any device, anytime, anywhere. Stream at home on your desktop or on the go via mobile. Our player makes your entire video library portable.</p>

        <p>Seamless streaming, smooth playback, and unlimited accessibility. Our video player transforms how you experience your personal video collection, no matter the format or device. Cloud streaming brings freedom.</p>

        <h3>Audio Streaming</h3>

        <p>The audio player within our platform allows you to upload and listen to music straight from the cloud. Popular formats like MP3, FLAC, M4A, WAV and more are supported. Create playlists, shuffle songs, and stream audio continuously with our robust cloud-based player.</p>

        <p>Our integrated audio player brings your music collection to the cloud for seamless streaming. Simply upload your audio files, including popular formats like MP3, FLAC, M4A, WAV plus many more. Cloud storage removes device limitations, making your music accessible anywhere.</p>

        <p>Within the player, create and organize playlists to match your mood. Shuffle songs for randomized enjoyment. Stream continuously without interruptions thanks to optimized performance. Album art and ID3 tags are automatically fetched for an enhanced listening experience.</p>

        <p>Access and play your audio library from any location on any device. Our cloud-based audio player untethers your music and makes it mobile. Stream songs at home or on the go. Rediscover your music with the freedom of the cloud.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>PDF Reader</h2>

        <p>Our integrated PDF reader means you can open and view PDFs right within the platform. No need for external PDF software. Just access your uploaded PDFs in the Seedr drive and leverage in-browser viewing tools like zoom, search, bookmarks and more for ultimate convenience.</p>

        <p>PDFs uploaded to your personal Seedr storage can be directly accessed through our integrated PDF reader. The reader opens PDFs in-browser for instant viewing without needing external software. Streamline your workflow.</p>

        <p>Robust viewing tools enhance the experience. Smoothly zoom in and out to scale pages. Search text to rapidly find keywords. Add bookmarks for quick navigation. Clickable links make documents interactive. Everything works flawlessly in-browser.</p>

        <p>The reader even optimizes text reflow for mobile devices. On any screen, PDFs can be viewed, searched, and navigated with ease. Experience convenience without limits.</p>

        <p>Our seamless PDF integration eliminates the need for third-party software. View, search, bookmark and interact with PDFs directly within our cloud-based platform. No downloads or separate apps required. Unlock simplified PDF workflows.</p>
      </div>
      <div class="products-details-child paragraph grey">
        <h2>EPUB Reader</h2>

        <p>For ebook lovers, our EPUB reader enables direct reading of EPUB files stored in your Seedr cloud drive. The reader mimics an e-reader experience while removing device limitations. Adjust font styles and sizes for optimal reading right in your browser.</p>

        <p>Our EPUB reader integrates seamlessly into our platform, allowing you to access EPUB-formatted ebooks directly from your personal cloud storage. The reader recreates a familiar e-reader environment tailored for digital book enjoyment.</p>

        <p>Once EPUBs are uploaded to your Seedr drive, open them in the reader to begin reading. Mimicking an e-reader, the interface enables quick page turns, highlights, bookmarks and adjustable fonts. Customize styles and sizes for your perfect reading experience.</p>

        <p>Since EPUBs are stored and streamed from the cloud, you can pick up where you left off on any device. Access your full digital library on the go without downloading books to multiple devices. Our EPUB reader removes device limitations.</p>

        <p>For ebook lovers, our integrated EPUB reader provides an enhanced reading experience. All the features you love from e-readers now accessible through any browser. Your books - everywhere you go.</p>
      </div>
      <div class="products-details-child paragraph grey last">
        <h2>Conclusion</h2>

        <p>Our unified media player combines video and audio functionalities in one centralized platform. Now you can access all your digital videos and music seamlessly from one login. Stream, manage, and enjoy all your cloud-stored media content. Try our all-in-one player today for the ultimate streaming experience!</p>

        <p>Seamless convergence of key media formats into one sleek player. Unlimited access to your personal cloud library from any device. Smooth streaming and playback optimized for each format. Intuitive tools tailored to enhance your videos and audio. Our universal player has it all.</p>

        <p>Experience the convenience of an all-in-one destination for your videos and music. End the fragmentation of juggling multiple services and apps. Streamline your digital life with a single integrated player.</p>

        <p>Upload your favorite media to the cloud and watch your personal library come alive. Our player removes all limitations, making your content accessible anywhere, anytime, on any device. The possibilities are endless.</p>

        <p>Convergence is the future. Unify your digital life with our universal media player. It's time to simplify.</p>
      </div>

      <div class="products-details-child cta">
        <span><a href="https://www.seedr.cc/pulse/">{{ $t('products-video.details.cta') }}</a></span>
      </div>
    </section>

    <section class="products-start-parent">
      <div class="products-start-child start-now-group">
        <h1>Get Stuff Quickly & Easily</h1>
        <SButton class="button-fill button-primary" btn-link="https://www.seedr.cc/premium" icon-font="s-icon-premium">Join Premium</SButton>
      </div>

      <div class="products-start-child advantages-group">
        <span class="advantages"><s-icon class="icon"  icon-font="s-icon-link"/>Paste a link from another website</span>
        <span class="advantages"><s-icon class="icon" icon-font="s-icon-clock-thick"/>Wait Few Seconds</span>
        <span class="advantages"><s-icon class="icon" icon-font="s-icon-download-line"/>Download & Stream on any device. Without Software</span>
      </div>
    </section>

    <section class="products-links-products">
      <h1>{{ $t('products.go-to-next-title') }} <span class="s-text-blue">feature</span></h1>
      <a class="" href="/products/streaming">
        <img src="/images/products_video_icon.svg" alt="icon">Stream Anywhere & Anytime
      </a>
      <a class="" href="/products/mobile">
        <img src="/images/products_mobile_icon.svg" alt="icon">Mobile Optimized
      </a>
      <a class="" href="/products/secure">
        <img src="/images/products_secure_icon.svg" alt="icon">Private and Secure
      </a>
    </section>

    <section class="products-faq">
      <div class="products-plans-questions">
        <h2>{{ $t('products.questions-title') }}</h2>
        <div class="products-plans-cta">

          <SButton class="button-secondary" btn-link="https://help.seedr.cc/hc/en-us">{{$t('actions.faq')}}</SButton>

          <SButton class="button-secondary" btn-link="https://help.seedr.cc/hc/en-us/requests/new">{{$t('actions.contact-us')}}</SButton>

        </div>
      </div>
    </section>
  </div>
</template>

<script>

import SButton from '/components/SButton.vue'
import SIcon from "/components/SIcon.vue";

export const documentProps = {
  title: 'Stream Seamlessly with Our All-in-One Media Player',
  description: 'Tired of constant app-switching to access videos and music? Our cloud media player combines streaming into one seamless destination. Enjoy unified access to your entire digital library.',
  keywords: 'stream videos in browser, stream music in browser, cloud video streaming, cloud music streaming, video streaming platform, music streaming platform, stream videos online, stream music online, video streaming service, music streaming service, stream personal video collection, stream personal music collection, stream home videos, stream mp3 collection, stream video library, stream music library, cloud-based video streaming, cloud-based music streaming, stream videos seamlessly, stream music seamlessly, smooth video streaming, smooth music streaming, stream videos without lag, stream music without lag, private video streaming, private music streaming, stream videos securely, stream music securely, stream videos from cloud, stream music from cloud, unlimited video streaming, unlimited music streaming, hands-free video streaming, hands-free music streaming, automated video uploads, automated music uploads, create video playlists, create music playlists, android video streaming app, ios music streaming app, mobile video streaming, mobile music streaming'
}

export default {
  components: {
    SButton,
    SIcon,
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss">

.products {
  height: 86.6vh;
  display: flex;
  flex-direction: column;
  margin: auto auto;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
